import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ICIRuleAction } from 'src/app/shared/models/ci-rule-action.model';

export const CI_RULE_ACTIONS_API_ACTIONS = createActionGroup({
  source: 'CI Rule Actions API',
  events: {
    get: emptyProps(),
    error: props<{ error: HttpErrorResponse }>(),
    success: props<{ data: ICIRuleAction[] }>(),
  },
});
